module.exports = __webpack_public_path__ + "8e48b4b7.svg";